import { ShoppingListDto } from '@api/*';

export interface ShoppingListStore {
    // Data
    shoppingLists: ShoppingListDto[];

    // Loading state
    loading: boolean;

    // Error state
    error: string | null;
}

export const initialShoppingListStore: ShoppingListStore = {
    shoppingLists: [],
    loading: false,
    error: null,
};
